// Formats listing and property prices for display; callers add currency labels.
export default function(price) {
	if (price === null || price === undefined) {
		return "";
	}

	const normalizedPrice = price.toString().trim().replace(/,/g, "");

	if (normalizedPrice === "") {
		return "";
	}

	const numericPrice = Number(normalizedPrice);

	if (!Number.isFinite(numericPrice) || numericPrice === 0) {
		return "";
	}

	return normalizedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
